const config = {
  basename: "",
  defaultPath: "/reporting-analytics/consolidate-sales",
  fontFamily: "Roboto-Regular",
  borderRadius: 5,
};

export default config;
